/**
 * Integer hash mixing for sim state digests (brief §5.1 hash(), §11.1).
 * FNV-1a-style over 32-bit lanes; allocation-free; exact on every engine.
 */

export const HASH_SEED = 0x811c9dc5;

/** Fold one integer value into a running 32-bit hash. */
export function mix(h: number, value: number): number {
  h = (h ^ (value & 0xffff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  h = (h ^ ((value >>> 16) & 0xffff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  return h >>> 0;
}

/** Fold a whole integer array. */
export function mixAll(h: number, values: ArrayLike<number>): number {
  for (let i = 0; i < values.length; i += 1) h = mix(h, values[i] as number);
  return h;
}
